import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'src/utils/store'
import { useTheme } from 'styled-components'
import { actions } from '../../ReceivementState'
import notes from 'src/assets/images/other-images/notes.svg'
import check from 'src/assets/images/other-images/check.svg'
import * as S from './styles'
import * as selectors from '../../ReceivementSelectors'

interface Props {
  observations: string[];
  modelId: number;
}

const ReceivementFinishObservations: React.FC<Props> = ({ observations, modelId }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const ref = React.useRef<HTMLSpanElement>(null)
  const [showObservations, setShowObservations] = useState(false)
  const observationPosition = useSelector(selectors.selectObservationsPositionByModelId)[modelId]
  const showIcon = !observationPosition
  const resetObservations = useSelector((state) => state.receivement.resetObservations)

  React.useEffect(() => {
    if (resetObservations) {
      setShowObservations(false)
      dispatch(actions.updateResetObservations(false))
    }
  }, [dispatch, resetObservations])

  React.useEffect(() => {
    if (ref.current && observationPosition === undefined) {
      dispatch(
        actions.addObservationPosition({
          modelId,
          position: ref.current.getBoundingClientRect().y - 80,
        }),
      )
    }
  }, [dispatch, modelId, observationPosition])

  const handleShowObservations = React.useCallback(() => {
    setShowObservations((prevState) => !prevState)
    if (!showIcon) {
      dispatch(actions.setObservationPositionToNaN({ modelId }))
    }
  }, [dispatch, modelId, showIcon])

  return (
    <>
      <S.ObservationsTableBodyRow backgroundColor={theme.colors.gray} isHover={false}>
        <S.TableBodyCell flex={1} onClick={handleShowObservations} testId='show-observations'>
          <S.Observations ref={ref}>Anotações</S.Observations>
          <S.Observations style={{ marginLeft: 10 }} data-testid='observations-icon'>
            {showIcon && (
            <S.ImageContainer>
              <S.ImageCheck src={check} />
            </S.ImageContainer>
            )}
            <S.Image src={notes}/>
          </S.Observations>
        </S.TableBodyCell>
      </S.ObservationsTableBodyRow>
      {showObservations
        && observations.map((observation, index) => (
          observation && (
          <S.ObservationsValueTableBodyRow backgroundColor={theme.colors.gray} isHover={false} key={index}>
            <S.TableBodyCell flex={1}>
              <div
                style={{
                  backgroundColor: '#FFF',
                  width: '100%',
                  boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
                  borderRadius: '8px',
                  padding: '12px',
                }}
              >
                <span style={{ whiteSpace: 'pre-line' }}>
                  {observation}
                </span>
              </div>
            </S.TableBodyCell>
          </S.ObservationsValueTableBodyRow>
          )
        ))}
    </>
  )
}

export { ReceivementFinishObservations }
